import React, { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

/**
 * Floating scroll navigation buttons.
 * Go Up appears when scrolled down. Go Down appears when not at bottom.
 * Fixed position, always visible, above cookie banner.
 */
const ScrollNav = () => {
  const [showUp, setShowUp] = useState(false);
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowH = window.innerHeight;
      const docH = document.documentElement.scrollHeight;

      setShowUp(scrollY > 300);
      setAtBottom(scrollY + windowH >= docH - 150);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const scrollToBottom = () => window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });

  // Don't render if page is too short
  if (!showUp && atBottom) return null;

  return (
    <div
      className="fixed right-5 flex flex-col gap-2"
      style={{ bottom: '5rem', zIndex: 9999 }}
      data-testid="scroll-nav"
    >
      {showUp && (
        <button
          onClick={scrollToTop}
          data-testid="scroll-to-top-btn"
          className="w-11 h-11 rounded-full bg-purple-600 hover:bg-purple-500 text-white shadow-xl flex items-center justify-center transition-all duration-200 hover:scale-110 border border-purple-400/30"
          aria-label="Scroll to top"
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      )}
      {!atBottom && showUp && (
        <button
          onClick={scrollToBottom}
          data-testid="scroll-to-bottom-btn"
          className="w-11 h-11 rounded-full bg-gray-700 hover:bg-gray-600 text-white shadow-xl flex items-center justify-center transition-all duration-200 hover:scale-110 border border-gray-500/30"
          aria-label="Scroll to bottom"
        >
          <ChevronDown className="w-6 h-6" />
        </button>
      )}
    </div>
  );
};

export default ScrollNav;
